export interface TokenCard {
    expMonth?: string;
    expYear?: string;
    last4?: string;
    accttype?: string;
    business?: string;
}

export enum TokenType {
    Heartland = 'hps',
    Stripe = 'stripe',
    CardConnect = 'fiserv',
    Fake = 'fake',
    Unified = 'unified',
}

export enum TokenProvider {
    Heartland = 'hps',
    Stripe = 'stripe',
    CardConnect = 'fiserv',
    Fake = 'fake',
}

export class TokenData {
    type: TokenType = TokenType.Unified;
    customer: {
        address: {
            address?: string;
            line2?: string;
            line3?: string;
            city?: string;
            state?: string;
            zip: string;
            country?: string;
        };
        firstName?: string;
        lastName?: string;
        nameOnAccount?: string;
        email: string;
        phone?: string;
    };

    fake?: string;
    fiserv?: string;
    hps?: string;
    stripe?: string;

    card?: TokenCard;
    callback?: () => void;

    constructor(
        type: TokenProvider, token: string, customer: TokenData['customer'], card?: TokenCard, callback?: () => void
    ) {
        this[type] = token;
        this.customer = customer;
        if (card) {
            this.card = card;
        }
        if (callback) {
            this.callback = callback;
        }
    }
}
